// Détection tactile, UNE FOIS au boot (constante de session, pas de bascule dynamique).
// ?touch : crochet de dev qui force le mode tactile (captures headless, test à la souris).
export const isTouch: boolean =
  matchMedia('(pointer: coarse)').matches || /[?&]touch\b/.test(location.search)
